import { peekBoards } from "@/mocks/kanliao";

export default function SneakPeek() {
  const [remind, setRemind] = useState<number[]>([0, 1, 2, 3]);
  const toggle = (i: number) =>
    setRemind((prev) => (prev.includes(i) ? prev.filter((x) => x !== i) : [...prev, i]));

  return (
    <section id="peek" className="bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold tracking-widest text-primary-600">
              <i className="ri-eye-fill" />
              SNEAK · 抢先看
            </p>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              5看料新料预告，抢先蹲坑
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              还没落地的瓜，先占好位置。预约人数一到，第一时间开砸。
            </p>
          </div>
          <span className="inline-flex items-center gap-1.5 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-700">
            <i className="ri-arrow-down-circle-line" />
            新料自动推送，抢先看不迷路
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {peekBoards.map((p, i) => {
            const on = remind.includes(i);
            return (
              <article
                key={p.title}
                className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
              >
                <div className="relative h-36 w-full overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.title}
                    title={p.title}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-1 text-[11px] font-black text-foreground-950">
                    <i className="ri-eye-line" />
                    抢先看
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-4">
                  <div className="flex items-center justify-between text-[11px] text-foreground-500">
                    <span className="rounded-full bg-primary-100 px-2 py-0.5 font-semibold text-primary-700">
                      {p.type}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line text-accent-600" />
                      {p.when}
                    </span>
                  </div>
                  <h3 className="mt-2.5 line-clamp-2 text-[14px] font-semibold leading-snug text-foreground-950">
                    {p.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                    {p.desc}
                  </p>
                  <div className="mt-3 flex items-center gap-2 text-[11px] text-foreground-500">
                    <i className="ri-user-add-line" />
                    {p.lock.toLocaleString()} 人已预约
                  </div>
                  <button
                    type="button"
                    onClick={() => toggle(i)}
                    className={
                      "mt-3 inline-flex w-full cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md px-3 py-2 text-xs font-semibold transition-colors " +
                      (on
                        ? "bg-accent-100 text-accent-800"
                        : "bg-accent-500 text-foreground-950 hover:bg-accent-600")
                    }
                  >
                    <i className={on ? "ri-notification-fill" : "ri-notification-line"} />
                    {on ? "已开蹲提醒" : "到点叫我"}
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}